export const cubes3d = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M6.5 4L11 2L15.5 4M6.5 4L11 6M6.5 4V9.5M15.5 4L11 6M15.5 4V9.5M11 6V11.5M11 11.5L15.5 9.5M11 11.5L6.5 9.5M11 11.5L15.5 13.5M11 11.5V17M11 11.5L6.5 13.5M15.5 9.5L20 11.5M6.5 9.5L2 11.5M20 11.5L15.5 13.5M20 11.5V17L15.5 19M15.5 13.5V19M15.5 19L11 17M11 17L6.5 19M2 11.5L6.5 13.5M2 11.5V17L6.5 19M6.5 13.5V19"
    stroke="currentColor"
    strokeWidth={1.5}
    fill="none"
  />
);
